import { createFileRoute } from '@tanstack/react-router'

import { orgFeesQueryOptions } from '@/queries/organization'

export const Route = createFileRoute(
  '/_unauthenticated/setup/payment-selection'
)({
  loader: ({ context: { orgStore, queryClient } }) =>
    queryClient.ensureQueryData(orgFeesQueryOptions(orgStore.getState().orgId)),
})
